import { Injectable } from '@angular/core'

import { PkwDatastore } from '../../pkw-data/pkw-datastore'
import { environment } from '../../../environments/environment'
import { SolicitacaoOperadora } from '../../pkw-data/collect/solicitacao-operadora.model'

@Injectable()
export class SolicitacaoOperadoraService {
    constructor(private pkwDatastore: PkwDatastore) { }

    novo() {
        const solicitacaoOperadora = this.pkwDatastore.createRecord(SolicitacaoOperadora)
        return solicitacaoOperadora
    }

    montarCustomUrl(queryString: string): string {
        const baseURL = environment.collectJsonApiBaseUrl;
        const endpoint = 'solicitacao-operadoras-de-maquina';

        return `${baseURL}/${endpoint}?${queryString}`;
    }

    salvar(solicitacaoOperadora: SolicitacaoOperadora) {
        return solicitacaoOperadora.save()
    }
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/solicitacao-operadora/solicitacao-operadora.service.ts